import { identity } from 'ramda'
import { LOGOUT_SUCCESS, REMOVE_ACCOUNT_SUCCESS } from '../types/authTypes'
import { eventTypeMap } from './constants'
import * as t from './types'

export { name } from './constants'

export const initialState = {}

export const persistence = {
  clear: identity,
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGOUT_SUCCESS:
    case REMOVE_ACCOUNT_SUCCESS:
      return {
        ...state,
        [t.AUTH]: undefined,
        [t.START]: undefined,
        [t.SESSION]: undefined,
      }

    default: {
      if (eventTypeMap[action.type]) {
        return {
          ...state,
          [action.type]: action,
        }
      }

      return state
    }
  }
}
